module.exports = __webpack_public_path__ + "img/gt.c15face7.png";